import { render } from "./BonusSingle.vue?vue&type=template&id=72a091a8&scoped=true"
import script from "./BonusSingle.vue?vue&type=script&lang=js"
export * from "./BonusSingle.vue?vue&type=script&lang=js"

import "./BonusSingle.vue?vue&type=style&index=0&id=72a091a8&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a091a8"]])

export default __exports__